import React from 'react';

import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import { Body as DialogBody, Heading as DialogHeading } from 'components/dialog';

import {
  ButtonContainer,
  CloseButton,
  ContinueButton,
  Description,
  Heading,
  Modal,
} from './styled';

export interface ILoyaltyReadyToRedeemModalProps {
  onDismiss: VoidFunction;
  onConfirm: VoidFunction;
  heading: string;
}

export const LoyaltyReadyToRedeemModal: React.FC<ILoyaltyReadyToRedeemModalProps> = ({
  onConfirm,
  onDismiss,
  heading,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      className="loyalty-ready-to-redeem-modal"
      heading={heading}
      headingComponent={
        <DialogHeading data-testid="dialog-heading">
          <Heading>{heading}</Heading>
        </DialogHeading>
      }
      body={formatMessage({ id: 'confirmDialogBody' })}
      bodyComponent={
        <DialogBody aria-live="polite">
          <Description>{formatMessage({ id: 'confirmDialogBody' })}</Description>
        </DialogBody>
      }
      image={null}
      onDismiss={onDismiss}
      actions={
        <ButtonContainer>
          <ContinueButton onlyIcon fullWidth onClick={onConfirm} data-testid="dialog-confirm-btn">
            {formatMessage({ id: 'confirmDialogReady' })}
          </ContinueButton>
          <CloseButton
            variant={ActionButtonVariants.OUTLINE}
            fullWidth
            onClick={onDismiss}
            data-testid="dialog-close-btn"
          >
            {formatMessage({ id: 'notNow' })}
          </CloseButton>
        </ButtonContainer>
      }
      modalAppearanceEventMessage="Confirm Ready to Redeem"
    />
  );
};
